import React from 'react';

const ImmunizationsForm: React.FC = () => {
  return (
    <div className="family-form">
      <div className="section-title">Immunizations</div>
      <p>Please give us a copy of previous <strong>Immunizations / Vaccines</strong> and <strong>TB (Tuberculosis) Testing</strong> or <strong>BCG Vaccination</strong>.</p>
    </div>
  );
};

export default ImmunizationsForm;


